import { render, staticRenderFns } from "./GangmasterCaseList.vue?vue&type=template&id=ca8d7e86&scoped=true"
import script from "./GangmasterCaseList.vue?vue&type=script&lang=js"
export * from "./GangmasterCaseList.vue?vue&type=script&lang=js"
import style0 from "./GangmasterCaseList.vue?vue&type=style&index=0&id=ca8d7e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8d7e86",
  null
  
)

export default component.exports